export class DateRangeResponseModel {
  StartDate: Date;
  EndDate: Date;

  constructor() {

  }
}
